<script setup lang="ts">
const props = defineProps({
  file: null,
  peek: { type: Boolean }
})

const renderer = useTemplateRef("renderer")
const src = computed(() => props.file.linkDestinationUrl())
const onLoad = () => {
  console.debug("Renderer loaded")
}
</script>

<template>
  <div class="renderer-container" tabindex="0">
    <iframe
      ref="renderer"
      tabindex="-1"
      class="renderer-iframe"
      :src
      @load="onLoad"
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.renderer-container
  @apply h-full w-full flex items-center justify-center relative

.renderer-iframe
  @apply absolute top-0 left-0 w-full h-full

.renderer-monaco
  @apply w-full h-full
  // override the vscode.focusBorder css variable
</style>
